module.exports = __webpack_public_path__ + "img/main.27b5cd0f.png";